import { render, staticRenderFns } from "./FailureMode_PieChart.vue?vue&type=template&id=2087c34e&scoped=true"
import script from "./FailureMode_PieChart.vue?vue&type=script&lang=js"
export * from "./FailureMode_PieChart.vue?vue&type=script&lang=js"
import style0 from "./FailureMode_PieChart.vue?vue&type=style&index=0&id=2087c34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087c34e",
  null
  
)

export default component.exports